module.exports = __webpack_public_path__ + "static/media/icon_close.c7bf0779.svg";